import { getUrl } from "./get-url";

export const getImagePath = (filename: string) => {
    return getUrl(`/api/image/${filename}`);
}